
import { ILegacyInfoDtoModel } from "../models/legacy-info/legacy-info-dto.model";
import { ILegacyInfoModel } from "../models/legacy-info/legacy-info.model";
import { IModelMapping } from "./generic/model.mapping";
export class LegacyInfoMapping implements IModelMapping<ILegacyInfoDtoModel, ILegacyInfoModel> {

    toApplicationModel(model: ILegacyInfoDtoModel): ILegacyInfoModel {
        return {
            ...model
        } as ILegacyInfoModel
    }

    toDtoModel(model: ILegacyInfoModel): ILegacyInfoDtoModel {
        return {
            ...model
        } as ILegacyInfoDtoModel
    }

    toDtoModels(models: ILegacyInfoModel[]): ILegacyInfoDtoModel[] {
        return models.map(m => this.toDtoModel(m));
    }

    toApplicationModels(models: ILegacyInfoDtoModel[]): ILegacyInfoModel[] {
        return models.map(m => this.toApplicationModel(m));
    }

}